export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5162.5ed5e792.jpg";